"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BrandedBasecamp() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="branded-basecamp" className="dark bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative w-full aspect-[4/5] lg:aspect-square rounded-sm overflow-hidden group">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1622697/img/abstract_concrete_staircase.png" alt="Abstract minimalist architectural structure" className="w-full h-full object-cover transition-transform duration-1000 ease-in-out group-hover:scale-105" />
            {}
            <div className="absolute inset-0 bg-primary/20 mix-blend-overlay transition-opacity duration-700 group-hover:opacity-80"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent lg:hidden"></div>
            {}
            <div className="absolute inset-0 ring-1 ring-inset ring-white/10 rounded-sm pointer-events-none"></div>
          </div>

          {}
          <div className="flex flex-col items-start z-10">
            <Badge variant="outline" className="uppercase tracking-widest text-xs mb-8 border-primary/40 text-primary bg-transparent px-3 py-1 rounded-none">
              Primary Focus
            </Badge>
            
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-semibold mb-6 tracking-tight text-foreground leading-tight">
              Branded Basecamp
            </h2>
            
            <p className="text-lg md:text-xl text-muted-foreground mb-10 leading-relaxed font-sans max-w-xl">
              Pre-revenue precision for early-stage founders. Validate, build, and scale your product, service, or tech venture with operator-level support designed to reduce burnout and accelerate execution.
            </p>
            
            <Button size="lg" asChild className="bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-8 text-base rounded-sm transition-colors duration-300">
              <Link to="https://brandbasecamp.io" newTab>
                Explore Branded Basecamp
                <ArrowRight className="ml-3 size-5 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}